import React from 'react';
import { BaseButton } from '../../../../../BaseComponents';
import { AcceptCheckinRules, useStartCheckIn } from '@features/start-check-in';
import { useTranslation } from 'react-i18next';
const StartCheckInButton = ({ buttonClassName }) => {
    const { t } = useTranslation('OrderCard');
    const { loading, isCheckinAvailable, isRulesModalOpen, closeRulesModal, checkinRules, acceptRules, goToCheckin } = useStartCheckIn();
    if (!isCheckinAvailable) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseButton, { className: buttonClassName, isLoading: loading, onClick: goToCheckin }, t('Check-in')),
        checkinRules && (React.createElement(AcceptCheckinRules, { isOpen: isRulesModalOpen, onClose: closeRulesModal, rules: checkinRules, onSubmit: acceptRules }))));
};
export default StartCheckInButton;
